export default "__VITE_ASSET__DrENP0UE__"